import React from "react";
import { Button, Popconfirm } from "antd";
import { GiConfirmed } from "react-icons/gi";
import { useUpdate } from "@refinedev/core";

type Props = {
  id: string;
  onDone: () => void;
  disabled?: boolean;
};

function ButtonApproveReceipt({ id, onDone, disabled }: Props) {
  const { isLoading, mutateAsync } = useUpdate();

  const onConfirm = async () => {
    await mutateAsync(
      {
        dataProviderName: "defaultV2",
        resource: `receipts/${id}/confirm`,
        values: {},
        id: "",
      },
      {
        onSuccess: () => {
          onDone();
        },
      }
    );
  };

  return (
    <Popconfirm
      title="Duyệt mã thanh toán?"
      description="Duyệt mã thanh toán sẽ cộng tiền vào trong tài khoản này. Bạn có chắc không?"
      onConfirm={onConfirm}
      // onCancel={cancel}
      okText="Duyệt"
      cancelText="Huỷ"
      disabled={disabled}
    >
      <Button
        size="small"
        icon={<GiConfirmed />}
        color="primary"
        disabled={disabled}
        loading={isLoading}
      />
    </Popconfirm>
  );
}

export default ButtonApproveReceipt;
